/**
 * Fixes article bodies pasted into admin with single line breaks
 * so Markdown renders headings, lists, and paragraphs correctly.
 */
export function normalizeArticleMarkdown(body) {
    if (!body || typeof body !== "string") return "";

    let text = body.replace(/\r\n/g, "\n").trim();
    const doubleBreaks = (text.match(/\n\n/g) || []).length;

    if (doubleBreaks >= 4) {
        return text;
    }

    const lines = text.split("\n");
    const blocks = [];
    let paragraphBuffer = [];

    const flushParagraph = () => {
        if (!paragraphBuffer.length) return;
        blocks.push(paragraphBuffer.join(" "));
        paragraphBuffer = [];
    };

    for (const rawLine of lines) {
        const line = rawLine.trim();
        if (!line) {
            flushParagraph();
            continue;
        }
        if (/^#{1,6}\s/.test(line) || /^[-*]\s/.test(line) || /^\d+\.\s/.test(line)) {
            flushParagraph();
            blocks.push(line);
            continue;
        }
        if (/^\|.+\|$/.test(line)) {
            flushParagraph();
            blocks.push(line);
            continue;
        }
        paragraphBuffer.push(line);
    }
    flushParagraph();

    return blocks.join("\n\n");
}
